var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import equal from 'fast-deep-equal';
import { Checkbox, FormGroup, FormControl, FormLabel, FormControlLabel, FormHelperText, } from '@mui/material';
import { fieldValueIsSame, localeIsSame, } from '../../utils/formik';
var CheckboxGroup = function (_a) {
    var items = _a.items, _b = _a.error, error = _b === void 0 ? false : _b, label = _a.label, name = _a.name, _c = _a.value, value = _c === void 0 ? [] : _c, onChange = _a.onChange, helperText = _a.helperText;
    var handleChange = React.useCallback(function (event) {
        if (!onChange) {
            return;
        }
        var checkboxValue = event.target.value;
        if (event.target.checked) {
            onChange(__spreadArray(__spreadArray([], value, true), [checkboxValue], false), checkboxValue);
        }
        else {
            onChange(value.filter(function (c) { return c !== checkboxValue; }), undefined);
        }
    }, [onChange, value]);
    return (React.createElement(FormControl, { component: "fieldset", error: error },
        label && React.createElement(FormLabel, { component: "legend" }, label),
        React.createElement(FormGroup, { row: true }, items.map(function (_a) {
            var label = _a.label, val = _a.value;
            return (React.createElement(FormControlLabel, { key: val, label: label, control: React.createElement(Checkbox, { value: val, name: name, checked: value.includes(val), onChange: handleChange }) }));
        })),
        helperText && React.createElement(FormHelperText, null, helperText)));
};
export default CheckboxGroup;
var FormikRadioGroupUnmemoized = function (_a) {
    var _b = _a.formik, errors = _b.errors, setFieldValue = _b.setFieldValue, values = _b.values, items = _a.items, checkboxGroupProps = __rest(_a, ["formik", "items"]);
    var nameAsKey = checkboxGroupProps.name;
    var handleChange = React.useCallback(function (values, _checkedValue) {
        setFieldValue(checkboxGroupProps.name, values);
    }, [checkboxGroupProps.name, setFieldValue]);
    return (React.createElement(CheckboxGroup, __assign({ items: items, onChange: checkboxGroupProps.onChange || handleChange, error: Boolean(errors[nameAsKey]), value: values[nameAsKey], helperText: errors[nameAsKey] }, checkboxGroupProps)));
};
var itemsAreSame = function (prevProps, nextProps) {
    if (prevProps.items.some(function (item) { return typeof item.label !== 'string'; }) ||
        nextProps.items.some(function (item) { return typeof item.label !== 'string'; })) {
        return equal(prevProps.items.map(function (item) { return item.value; }), nextProps.items.map(function (item) { return item.value; }));
    }
    else {
        return equal(prevProps.items, nextProps.items);
    }
};
export var FormikCheckboxGroup = React.memo(FormikRadioGroupUnmemoized, function (prevProps, nextProps) {
    return localeIsSame(prevProps, nextProps) &&
        fieldValueIsSame(prevProps, nextProps) &&
        itemsAreSame(prevProps, nextProps);
});
